import { useCallback, useContext, useState } from 'react';
import MoreHorizIcon from '@mui/icons-material//MoreHoriz';
import RefreshIcon from '@mui/icons-material//Refresh';
import { ValuationService } from 'api';
import {
  refreshGPCOptionClasses,
  RefreshGPCOptionMenuItem,
  RefreshGPCOptionProgress,
  RefreshGPCOptionRoot,
} from 'pages/Valuations/components/RefreshGPCOption/RefreshGPCOption.styles';
import ValuationContext from 'pages/ValuationsAllocation/ValuationContext';
import { RefreshBacksolveSourceRowsOptionProps } from './RefreshBacksolveSourceRowsOption.props';

const RefreshBacksolveSourceRowsOption = ({
  approach,
  approaches,
  setApproaches,
  closeApproachMenu,
}: RefreshBacksolveSourceRowsOptionProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { valuation } = useContext(ValuationContext);

  const refreshSourceRows = useCallback(async () => {
    const backsolveId = approach?.valuations_approach_backsolve?.id;
    if (isLoading || !backsolveId) {
      return;
    }

    setIsLoading(true);
    try {
      const updatedBacksolve = await ValuationService.apiValuationRefreshBacksolveSourceRowsCreate(
        String(backsolveId)
      );

      const refreshedApproaches = approaches.map(a => {
        if (a.panelId === approach?.panelId) {
          return {
            ...a,
            valuations_approach_backsolve: {
              ...a.valuations_approach_backsolve,
              source_rows: updatedBacksolve.source_rows ?? [],
              securities_basket: updatedBacksolve.securities_basket ?? a.valuations_approach_backsolve?.securities_basket,
            },
          } as typeof a;
        }
        return a;
      });

      closeApproachMenu();

      if (valuation) {
        valuation.valuations_approaches = [...refreshedApproaches];
      }

      setApproaches([...refreshedApproaches]);
    } finally {
      setIsLoading(false);
    }
  }, [approach, approaches, isLoading, closeApproachMenu, setApproaches, valuation]);

  return (
    <RefreshGPCOptionRoot>
      {isLoading && <RefreshGPCOptionProgress />}
      <RefreshGPCOptionMenuItem onClick={refreshSourceRows}>
        <span className={refreshGPCOptionClasses.icon}>{isLoading ? <MoreHorizIcon /> : <RefreshIcon />}</span>
        <span className={refreshGPCOptionClasses.content}>
          <span className={refreshGPCOptionClasses.title}>{isLoading ? 'Refreshing' : 'Refresh Source Data'}</span>
          <span className={refreshGPCOptionClasses.meta}>Re-import transactions from linked sources</span>
        </span>
      </RefreshGPCOptionMenuItem>
    </RefreshGPCOptionRoot>
  );
};

export default RefreshBacksolveSourceRowsOption;
